/** @jsxImportSource @emotion/react */

import { PATH } from "constants/path";
import { NavLink } from "react-router-dom";

import { AnnouncementHeaderStyle } from "./index.style";

const AnnouncementHeader = () => {
  
  return (
    <div css={AnnouncementHeaderStyle.wrapper}>
      <header css={AnnouncementHeaderStyle.self}>
        <h1 css={AnnouncementHeaderStyle.title}> {"資訊中心"}</h1>
        <ul css={AnnouncementHeaderStyle.tabs}>
          <li css={AnnouncementHeaderStyle.tabItem}>
            <NavLink to={PATH.PersonalMessage}> {"個人訊息"}</NavLink>
            <span></span>
          </li>
          <li css={AnnouncementHeaderStyle.line}></li>
          <li css={AnnouncementHeaderStyle.tabItem}>
            <NavLink to={PATH.Annoucement}>{"通知"}</NavLink>
            <span></span>
          </li>
        </ul>
      </header>
    </div>
  );
};

export default AnnouncementHeader;
